// components/DurationDisplay.tsx

import React from 'react';
import './DurationDisplay.css';

interface DurationDisplayProps {
  initialCastTimestamp: number; // Timestamp when ability was initially cast
  currentTimestamp: number; // Current timestamp from the recast KeyPress event
}

const DurationDisplay: React.FC<DurationDisplayProps> = ({ initialCastTimestamp, currentTimestamp }) => {
  // Calculate duration in seconds (time between initial cast and recast)
  const durationMs = currentTimestamp - initialCastTimestamp;
  const durationSeconds = (durationMs / 1000).toFixed(1);

  return (
    <div className="duration-display">
      <div className="duration-value">
        <div className="duration-time">{durationSeconds}s</div>
        <div className="duration-label">Duration</div>
      </div>
    </div>
  );
};

export default DurationDisplay;

